import React from 'react';
import { PersonCombobox } from './PersonCombobox';

/**
 * The Client/Lead selector: a PersonCombobox over the company's people with role 'client'. In this data model a
 * "Lead" and a "Client" are the SAME underlying entity (`user_company_relation.role = 'client'`, distinguished only by
 * `users.lead_status`, not by a separate role/table) -- so one component correctly serves both. Used by New Project's
 * Client field and Proposals' Lead field. All behaviour lives in PersonCombobox.
 */
export interface ClientLeadSelection {
  client_id: string | null;
  client_name: string;
}

interface ClientLeadComboboxProps {
  value: string;
  onChange: (selection: ClientLeadSelection) => void;
  placeholder?: string;
  className?: string;
  onCreateNew?: () => void;
  /** Bump this (e.g. after creating a new client/lead elsewhere) to force an immediate refetch of the list without remounting the field. */
  refreshToken?: number;
  /** false for a field that must have a client (no gray "Select" option) */
  clearable?: boolean;
}

export function ClientLeadCombobox({ onChange, ...props }: ClientLeadComboboxProps) {
  return <PersonCombobox roles={['client']} onChange={({ id, name }) => onChange({ client_id: id, client_name: name })} {...props} />;
}
